import { useEffect } from 'react';
import { trackEvent } from 'helpers';

const useTracking = (eventName: string, data?: any, dependencies = []) => {
  useEffect(() => {
    if (eventName) {
      trackEvent(eventName, data);
    }
  }, dependencies);
};

export default useTracking;
